export default "__VITE_ASSET__CTqPzjkM__"